export const END_CTA_DURATION_SECONDS = 1.5;

const clamp01 = (value: number): number => Math.max(0, Math.min(1, value));
const smooth = (value: number): number => {
  const t = clamp01(value);
  return t * t * (3 - 2 * t);
};

export const getEndCtaDurationFrames = (fps: number): number =>
  Math.max(1, Math.round(END_CTA_DURATION_SECONDS * fps));

export const getEndCtaTiming = (frame: number, fps: number) => {
  const duration = getEndCtaDurationFrames(fps);
  const enter = smooth(frame / Math.max(1, Math.round(fps * 0.22)));
  const remaining = duration - 1 - frame;
  const leave = smooth(remaining / Math.max(1, Math.round(fps * 0.23)));
  const pulseCenter = Math.round(fps * 0.52);
  const pulse = clamp01(
    1 - Math.abs(frame - pulseCenter) / Math.max(1, Math.round(fps * 0.18)),
  );
  const likeEnter = smooth(frame / Math.max(1, Math.round(fps * 0.24)));
  const likeKick = smooth(clamp01(1 - Math.abs(frame - Math.round(fps * 0.36)) /
    Math.max(1, Math.round(fps * 0.22))));
  return {
    opacity: Math.min(enter, leave),
    translateY: (1 - enter) * 28,
    scale: 0.96 + enter * 0.04,
    pulse: smooth(pulse),
    likeScale: 0.48 + 0.52 * likeEnter,
    likeLift: -8 * likeKick,
    likeRotate: -18 * likeKick,
    likeColorMix: likeEnter,
  };
};
